import {
  CompanyTagUnionType,
  useUpdateCompany as useUpdateCompanyApi,
} from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { CompanyFormSchemaType } from '../useCompanyFormSchema';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_COMPANY';

type UseUpdateCompanyReturnType = {
  updateCompany: (data: CompanyFormSchemaType) => Promise<void>;
};

export const useUpdateCompany = (
  companyId: string
): UseUpdateCompanyReturnType => {
  const { mutateAsync: updateCompanyMutation } = useUpdateCompanyApi();

  const { showSuccess, showError } = useNotification();

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateCompany = async (formValues: CompanyFormSchemaType) => {
    await updateCompanyMutation(
      {
        companyId,
        data: {
          ...formValues,
          tags: formValues.tags as CompanyTagUnionType[],
        },
      },
      { onSuccess, onError }
    );
  };

  return { updateCompany };
};
